import { JobResponseEntity } from "@/src/hooks/api/generated";

/**
 * Builds the destination the Apply button sends a candidate to.
 *
 * The organisation's `utm_code` is the tracking suffix clients measure their
 * applications by, so every route to the employer's form - the Apply button and
 * the automatic hand-off alike - must go through here rather than rebuilding
 * the string, otherwise the two can silently drift apart.
 */
export function buildJobApplyUrl(jobDetails: JobResponseEntity): string {
  return `${jobDetails?.apply_url}${jobDetails?.organization.utm_code ?? ""}`;
}
